
        // ===== Suggestion libraries =====

        // Negative keywords: common false-match patterns that work across
        // many subjects (other public people who might share a name).
        const NEGATIVE_KEYWORD_LIBRARY = [
            'the footballer', 'the actor', 'the actress', 'the singer',
            'the rapper', 'the YouTuber', 'the politician', 'the senator',
            'the MP', 'the academic', 'the professor', 'the journalist',
            'the chef', 'the surgeon', 'the lawyer', 'the comedian',
            'died in', 'obituary', 'deceased', 'historical',
            'fictional character', 'Wikipedia disambiguation',
        ];

export { NEGATIVE_KEYWORD_LIBRARY };
